import { IconInfo, IconWarning } from '@xing-com/icons';

import * as Styled from './hint.styles';
import type { HintProps } from './hint.types';

export const Hint: React.FC<HintProps> = ({
  className,
  children,
  variant,
  ...props
}) => (
  <Styled.Hint data-xds="Hint" className={className} role="alert" {...props}>
    <Styled.IconContainer $variant={variant}>
      {variant === 'error' && (
        <IconWarning aria-hidden="true" width={18} height={18} />
      )}
      {variant === 'info' && (
        <IconInfo aria-hidden="true" width={18} height={18} />
      )}
    </Styled.IconContainer>
    <Styled.Text $variant={variant} lineHeight="dense" size="xsmall" noMargin>
      {children}
    </Styled.Text>
  </Styled.Hint>
);

Hint.displayName = 'Hint';
